import { useCallback } from 'react';
import { NavMarker } from 'react-rhumb';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { HR } from 'foundations-components/transitional/components/HR';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LOGOUT_PATH } from '../../api/paths';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AccessDenied() {
  const handleLogout = useCallback(() => {
    window.location.href = `${LOGOUT_PATH}`;
  }, []);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "ACCESS_DENIED",
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      blockSize: "100dvh",
      padding: "800",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        alignItems: "start",
        gap: "500",
        maxInlineSize: "500px",
        backgroundColor: "fill-surface-default",
        borderRadius: "300",
        boxShadow: "100",
        padding: "800",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h1",
          typography: "heading-300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.accessDeniedHeading"
          })
        }), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(Text, {
          as: "p",
          typography: "body-200",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.accessDeniedBody"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleLogout,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.logOut"
          })
        })]
      })
    })
  });
}